var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.889 10.619h.032a5.314 5.314 0 0 0 5.309-5.31A5.315 5.315 0 0 0 7.92 0a5.316 5.316 0 0 0-5.31 5.308 5.3 5.3 0 0 0 5.279 5.312m-3.851-5.31A3.887 3.887 0 0 1 7.92 1.429 3.886 3.886 0 0 1 11.8 5.31a3.886 3.886 0 0 1-3.88 3.882h-.03A3.873 3.873 0 0 1 4.039 5.31M0 16.173c0 3.697 5.962 3.697 7.92 3.697 3.4 0 7.92-.38 7.92-3.677 0-3.697-5.96-3.697-7.92-3.697-3.4 0-7.92.381-7.92 3.677m1.5 0c0-1.445 2.16-2.177 6.42-2.177s6.42.74 6.42 2.197c0 1.445-2.16 2.177-6.42 2.177s-6.42-.739-6.42-2.197",
    clipRule: "evenodd"
  })));
};
export { SvgProfile as ReactComponent };